import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog',
    templateUrl: './vrs-response-dialog.component.html',
    styleUrls: ['./vrs-response-dialog.component.scss'],
})
export class VrsResponseDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data:  { message: string[], cfms_sites: string[], vrs_stations: [] },
        private dialogRef: MatDialogRef<VrsResponseDialogComponent>
    ) {}

    onCancel(): void {
        this.dialogRef.close(false); // Pass false for cancellation
      }
}